var makeSafeRequestIdleCallback = function () {
    if ('requestIdleCallback' in window) {
        return window.requestIdleCallback;
    }
    return function (callback) { return window.setTimeout(function () { return callback(); }, 0); };
};
export var requestIdleCallbackSafe = makeSafeRequestIdleCallback();
